import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { InquiryForm } from './InquiryForm';

export const ContactSection = () => {
  return (
    <section 
      id="contact" 
      className="py-20 lg:py-28 bg-white"
      data-testid="contact-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#C6A34A] uppercase tracking-widest text-sm font-medium mb-3">
            Get in Touch
          </p>
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1C2D] mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Contact the Chambers
          </h2>
          <div className="w-20 h-1 bg-[#C6A34A] mx-auto" />
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Contact Info & Map */}
          <div>
            {/* Contact Cards */}
            <div className="space-y-6 mb-8">
              <div className="flex items-start space-x-4 p-6 bg-[#F8F6F2] border border-gray-100">
                <div className="w-12 h-12 bg-[#0B1C2D] flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-[#C6A34A]" />
                </div>
                <div>
                  <h4 className="text-[#0B1C2D] font-semibold mb-1">Office Address</h4>
                  <address className="not-italic text-[#4A5568] text-sm leading-relaxed">
                    306, Devendra Residency,<br />
                    Kankarbagh Main Road,<br />
                    Patna, Bihar - 800026
                  </address>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-6 bg-[#F8F6F2] border border-gray-100">
                <div className="w-12 h-12 bg-[#0B1C2D] flex items-center justify-center flex-shrink-0">
                  <Phone className="w-6 h-6 text-[#C6A34A]" />
                </div>
                <div>
                  <h4 className="text-[#0B1C2D] font-semibold mb-1">Phone</h4>
                  <a 
                    href="tel:+919431078694"
                    className="text-[#4A5568] hover:text-[#C6A34A] transition-colors"
                    data-testid="contact-phone"
                  >
                    +91 9431078694
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-6 bg-[#F8F6F2] border border-gray-100">
                <div className="w-12 h-12 bg-[#0B1C2D] flex items-center justify-center flex-shrink-0">
                  <Mail className="w-6 h-6 text-[#C6A34A]" />
                </div>
                <div>
                  <h4 className="text-[#0B1C2D] font-semibold mb-1">Email</h4>
                  <div className="space-y-1">
                    <a 
                      href="mailto:ajeet.sinha@jurisbihar.com"
                      className="block text-[#4A5568] hover:text-[#C6A34A] transition-colors text-sm"
                      data-testid="contact-email-advocate"
                    >
                      ajeet.sinha@jurisbihar.com
                    </a>
                  </div>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-6 bg-[#F8F6F2] border border-gray-100">
                <div className="w-12 h-12 bg-[#0B1C2D] flex items-center justify-center flex-shrink-0">
                  <Clock className="w-6 h-6 text-[#C6A34A]" />
                </div>
                <div>
                  <h4 className="text-[#0B1C2D] font-semibold mb-1">Consultation Hours</h4>
                  <p className="text-[#4A5568] text-sm">
                    Monday - Saturday: 10:00 AM - 6:00 PM<br />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>

            {/* Google Maps Embed */}
            <div className="border border-gray-200 overflow-hidden" data-testid="google-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3598.0126654982137!2d85.1354113!3d25.5940597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed58a327e2f4a7%3A0x8a7f4c5f8f3b8a9e!2sDevendra%20Residency%20and%20Bimla%20Raj%20Enclave!5e0!3m2!1sen!2sin!4v1704000000000!5m2!1sen!2sin"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Office Location - Devendra Residency, Kankarbagh, Patna"
              />
            </div>
          </div>

          {/* Inquiry Form */}
          <div id="inquiry-form">
            <InquiryForm />
          </div>
        </div>
      </div>
    </section>
  );
};
